import { QueryHookOptions } from '@apollo/client';

import { UseGetSegmentsParams } from '@occc-app/dataAccessLayer/segment/types';
import { usePaginatedQuery } from '@occc-app/hooks/usePaginatedQuery';
import { useSegmentsQuery } from '@occc/graphql';

import { transformDataToSegmentsArray } from '../utils/transform-data-to-segments-array';

export const useGetSegments = ({
  filter,
  pageSize,
  baseOptions,
  paginationInfo,
  onPageChange,
}: UseGetSegmentsParams) => {
  const response = usePaginatedQuery(
    useSegmentsQuery,
    'segments.pageInfo',
    pageSize,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      variables: {
        filter,
      },
      ...baseOptions,
      onCompleted: (data) => {
        if (baseOptions && baseOptions.onCompleted) {
          baseOptions.onCompleted(transformDataToSegmentsArray(data));
        }
      },
    } as QueryHookOptions,
    paginationInfo,
    onPageChange,
  );

  return {
    ...response,
    data: response.data ? transformDataToSegmentsArray(response.data) : response.data,
  };
};
